module.exports = __webpack_public_path__ + "img/video2.fd8be630.jpg";